module.exports = __webpack_public_path__ + "static/media/Sail-Away.b40f85cb.jpg";